import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { ThemeListStore } from "../../store/ThemeListStore";

type ThemeListDialogsProps = {
  store: ThemeListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de Theme.
 * Separado para mantener ThemeListPage más limpio.
 */
export const ThemeListDialogs: React.FC<ThemeListDialogsProps> = observer(
  ({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  }
);
